// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__FYDyc","modalContent":"style_modalContent__QKJn2","topicsList":"style_topicsList__Lx81n"};